import * as consts from "../consts";

export function validateCards(cardBuilderSettings) {
  let errors = [];
  let cardDetails = [...cardBuilderSettings.cardDetails];
  if (cardDetails.length > 0 && cardBuilderSettings.cardImage.length > 0) {
    cardDetails.map((cardDetail) => {
      switch (cardBuilderSettings.cardType) {
        case consts.CARD_TYPE_PLASTIC:
          errors = [...errors, plasticMessageIssues(cardDetail.message)];
          if (cardDetail.shipping) {
            errors = [...errors, nameIssues(cardDetail.shipping.name)];
            errors = [...errors, addressIssues(cardDetail.shipping.address)];
            errors = [...errors, cityIssues(cardDetail.shipping.city)];
            errors = [...errors, stateIssues(cardDetail.shipping.state)];
            errors = [...errors, zipIssues(cardDetail.shipping.zip)];
          } else {
            errors = ["Must have a valid shipping address"];
          }
          break;
        case consts.CARD_TYPE_EMAIL:
          errors = [...errors, emailIssues(cardDetail.email)];
          if (cardDetail.emailOption == consts.EMAIL_TYPE_LATER) {
            errors = [...errors, deliveryDateIssues(cardDetail.deliveryDate)];
          }
          break;
        case consts.CARD_TYPE_PRINTER:
          errors = [...errors, printerMessageIssues(cardDetail.message)];
          break;
      }
    });
  } else {
    errors = [
      "Must have at least one card with a selected image to add to cart",
    ];
  }
  errors = errors.filter(Boolean);
  return errors;
}

export function validateBilling(billing) {
  let errors = [];
  if (billing) {
    errors = [...errors, emailIssues(billing.email)];
    errors = [...errors, firstNameIssues(billing.firstName)];
    errors = [...errors, lastNameIssues(billing.lastName)];
    errors = [...errors, addressIssues(billing.address)];
    errors = [...errors, cityIssues(billing.city)];
    errors = [...errors, stateIssues(billing.state)];
    errors = [...errors, zipIssues(billing.zip)];
    errors = [...errors, creditCardNumberIssues(billing.cardNumber)];
    errors = [...errors, creditCardCodeIssues(billing.cardCode)];
    errors = [...errors, creditCardExpirationIssues(billing.expiration)];
  } else {
    errors = ["Must have a valid billing information"];
  }
  errors = errors.filter(Boolean);
  return errors;
}

export function validateBillingAddress(billing) {
  let errors = [];
  if (billing) {
    errors = [...errors, firstNameIssues(billing.firstName)];
    errors = [...errors, lastNameIssues(billing.lastName)];
    errors = [...errors, addressIssues(billing.address)];
    errors = [...errors, cityIssues(billing.city)];
    errors = [...errors, stateIssues(billing.state)];
    errors = [...errors, zipIssues(billing.zip)];
  } else {
    errors = ["Must have a valid billing address"];
  }
  errors = errors.filter(Boolean);
  return errors;
}

export function validateBillingCreditCard(billing) {
  let errors = [];
  if (billing) {
    errors = [...errors, creditCardNumberIssues(billing.cardNumber)];
    errors = [...errors, creditCardCodeIssues(billing.cardCode)];
    errors = [...errors, creditCardExpirationIssues(billing.expiration)];
  } else {
    errors = ["Must have a valid billing credit card"];
  }
  errors = errors.filter(Boolean);
  return errors;
}

export function emailMessageIssues(message) {
  if (message && message.length > 900) {
    return "Message must be less than 900 characters";
  } else {
    return null;
  }
}

export function plasticMessageIssues(message) {
  if (message && message.length > 550) {
    return "Message must be less than 550 characters";
  } else {
    return null;
  }
}

export function printerMessageIssues(message) {
  if (message && message.length > 550) {
    return "Message must be less than 550 characters";
  } else {
    return null;
  }
}

export function shippingAddressMatch(cardBuilderSettings, cart) {
  let addressMatch = true;
  cart.map((cartItem, index) => {
    if (
      cartItem.cardType == consts.CARD_TYPE_PLASTIC &&
      cartItem.mailOption == consts.PLASTIC_TYPE_ME
    ) {
      cartItem.cardDetails.map((cardDetail, index) => {
        if (
          cartItem.cartItemID != cardBuilderSettings.cartItemID &&
          (cardDetail.shipping.name !=
            cardBuilderSettings.cardDetails[0].shipping.name ||
            cardDetail.shipping.company !=
              cardBuilderSettings.cardDetails[0].shipping.company ||
            cardDetail.shipping.address !=
              cardBuilderSettings.cardDetails[0].shipping.address ||
            cardDetail.shipping.city !=
              cardBuilderSettings.cardDetails[0].shipping.city ||
            cardDetail.shipping.state !=
              cardBuilderSettings.cardDetails[0].shipping.state ||
            cardDetail.shipping.zip !=
              cardBuilderSettings.cardDetails[0].shipping.zip)
        ) {
          addressMatch = false;
        }
      });
    }
  });
  return addressMatch;
}

export function firstNameIssues(firstName) {
  if (!firstName || firstName.length == 0) {
    return "First name is required";
  } else {
    return null;
  }
}

export function lastNameIssues(lastName) {
  if (!lastName || lastName.length == 0) {
    return "Last name is required";
  } else {
    return null;
  }
}

export function nameIssues(name) {
  if (!name || name.length == 0) {
    return "Name is required";
  } else {
    return null;
  }
}

export function addressIssues(address) {
  if (!address || address.length == 0) {
    return "Address is required";
  } else {
    return null;
  }
}

export function cityIssues(city) {
  if (!city || city.length == 0) {
    return "City is required";
  } else {
    return null;
  }
}

export function stateIssues(state) {
  if (!state || state.length == 0 || state == "SELECT") {
    return "State is required";
  } else {
    return null;
  }
}

export function zipIssues(zip) {
  if (!zip || zip.length == 0) {
    return "Zip is required";
  } else {
    if (!consts.VALIDATION_ZIP.test(zip)) {
      return "Not a valid zip code";
    } else {
      return null;
    }
  }
}

export function emailIssues(email) {
  if (!email || email.length == 0) {
    return "Email is required";
  } else if (!consts.VALIDATION_EMAIL.test(email)) {
    return "Not a valid email address";
  } else {
    return null;
  }
}

export function deliveryDateIssues(deliveryDate) {
  let date = new Date(deliveryDate);
  if (!deliveryDate || deliveryDate.length == 0) {
    return "Delivery date is required";
  } else if (date < new Date()) {
    return "Delivery date must be in the future";
  } else {
    return null;
  }
}

export function creditCardNumberIssues(creditCardNumber) {
  if (
    !creditCardNumber ||
    creditCardNumber.replace(/-/g, "").replace(/ /g, "").length == 0
  ) {
    return "Credit card number is required";
  } else if (
    !consts.VALIDATION_CREDIT_CARD.test(
      creditCardNumber.replace(/-/g, "").replace(/ /g, "")
    )
  ) {
    return "Not a valid credit card number";
  } else {
    return null;
  }
}

export function creditCardCodeIssues(creditCardCode) {
  if (!creditCardCode || creditCardCode.length == 0) {
    return "Credit card code is required";
  } else {
    if (creditCardCode.trim().length < 3 || creditCardCode.trim().length > 4) {
      return "Not a valid credit card code";
    } else {
      return null;
    }
  }
}

export function creditCardExpirationIssues(creditCardExpiration) {
  try {
    let splitExpiration = creditCardExpiration.split("/");
    let expirationMonth = parseInt(splitExpiration[0]);
    let expirationYear = parseInt(splitExpiration[1]);
    let date = new Date(expirationYear + 2000, expirationMonth, 0, 0, 0, 0, 0);
    if (!creditCardExpiration || creditCardExpiration.length == 0) {
      return "Credit card expiration is required";
    } else if (expirationMonth < 1 || expirationMonth > 12) {
      return "Credit card expiration month is not valid";
    } else if (date < new Date()) {
      return "Credit card expiration must be in the future";
    } else {
      return null;
    }
  } catch (exception) {
    return "Credit card expiration must be a valid date";
  }
}
